const defaultData = {
  card1: true,
  card2: true,
  card3: true,
  card4: true,
  card5: true,
  card6: true,
  card7: true,
  card8: true,
  card9: true,
  card10: true,
  card11: true,
  card12: true,
  card13: true,
  card14: true,
  card15: true,
  card16: true,
};

const getDataFromStorage = (storagedData, initialData) => {
  for (const key in storagedData) {
    initialData[key] = storagedData[key];
  }
  return initialData;
};

const initialState = window.localStorage.getItem("cards-dash-quality")
  ? getDataFromStorage(
      JSON.parse(window.localStorage.getItem("cards-dash-quality")),
      defaultData,
    )
  : defaultData;

const cardsOfQualityDash = (state = initialState, action) => {
  switch (action.type) {
    case "CHANGE_CARDS_QUALITY":
      return {
        card1: action.card1,
        card2: action.card2,
        card3: action.card3,
        card4: action.card4,
        card5: action.card5,
        card6: action.card6,
        card7: action.card7,
        card8: action.card8,
        card9: action.card9,
        card10: action.card10,
        card11: action.card11,
        card12: action.card12,
        card13: action.card13,
        card14: action.card14,
        card15: action.card15,
        card16: action.card16,
      };
    default:
      return state;
  }
};

export default cardsOfQualityDash;
